export default {
  getDadosRelatorio: state => state.dadosRelatorio,
}
